import React from 'react'
import { loadMailroomSettings, updateMailroomSettings } from './api/domecile'
import MailroomSettingsForm from './MailroomSettingsForm'

export default function DomecileMailroomSettings() {
  return <MailroomSettingsForm loadFn={loadMailroomSettings} saveFn={updateMailroomSettings} />
}
